import { render, staticRenderFns } from "./IdentificacaoReembolso.vue?vue&type=template&id=0a1e3058&scoped=true&"
import script from "./IdentificacaoReembolso.vue?vue&type=script&lang=js&"
export * from "./IdentificacaoReembolso.vue?vue&type=script&lang=js&"
import style0 from "./IdentificacaoReembolso.vue?vue&type=style&index=0&id=0a1e3058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1e3058",
  null
  
)

export default component.exports